import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Legacy bookmarks retain the monitoring layout's access checks; pricing checks its own access.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/reports/savings')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/monitoring/components/pricing', replace: true, search: true });
    },
});
